<template>
    <div class="sidebar flex flex-column">
        <div class="nav flex-none">
            <router-link v-if="enabledQueues.includes('new')" :class="{'nav-link': true, 'nav-link-active': queue === 'new'}" :to="createLinkTo({queue: 'new', chatId: null, details: 'pet'})">
                Jono
                <span class="count">{{newChats.length}}</span>
            </router-link>
            <router-link v-if="enabledQueues.includes('appointment')" :class="{'nav-link': true, 'nav-link-active': queue === 'appointment'}" :to="createLinkTo({queue: 'appointment', chatId: null})">
                Ajanvaraus
                <span class="count">{{appointmentChats.length}}</span>
            </router-link>
            <router-link v-if="enabledQueues.includes('own')" :class="{'nav-link': true, 'nav-link-active': queue === 'own'}" :to="createLinkTo({queue: 'own', chatId: null})">
                <div class="relative inline-block">
                    {{!profile.admin ? 'Omat' : 'Avoimet'}}
                    <span class="count">{{ownChats.length}}</span>
                    <div v-if="ownChatUnseenMessages" class="notification">
                      <UnseenMessagesIndicator :unseenMessages="ownChatUnseenMessages" />
                    </div>
                </div>
            </router-link>
            <router-link v-if="enabledQueues.includes('closed')" :class="{'nav-link': true, 'nav-link-active': queue === 'closed'}" :to="createLinkTo({queue: 'closed', chatId: null})">
                Suljetut
            </router-link>

            <div v-if="enabledQueues.length < 3" class="nav-link nav-spacer" />
        </div>

        <NewList v-if="queue === 'new'" :createLinkTo="createLinkTo" />
        <AppointmentList v-else-if="queue === 'appointment'" :createLinkTo="createLinkTo" />
        <OwnList v-else-if="queue === 'own'" :createLinkTo="createLinkTo" />
        <ClosedList v-else-if="queue === 'closed'" :createLinkTo="createLinkTo" />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

import UnseenMessagesIndicator from "@/components/reception/UnseenMessagesIndicator.vue";
import NewList from '@/components/reception/NewList.vue';
import AppointmentList from '@/components/reception/AppointmentList.vue';
import OwnList from '@/components/reception/OwnList.vue';
import ClosedList from '@/components/reception/ClosedList.vue';

export default {
    name: 'Sidebar',
    components: {
      UnseenMessagesIndicator,
      NewList,
      AppointmentList,
      OwnList,
      ClosedList,
    },
    props: {
      createLinkTo: Function,
      queue: String,
      enabledQueues: Array,
    },
    computed: {
      ...mapGetters({
        newChats: 'newChats',
        appointmentChats: 'appointmentChats',
        ownChats: 'ownChats',
        ownChatUnseenMessages: 'ownChatUnseenMessages',
        profile: 'profile',
      }),
    },
};
</script>

<style>
  :root {
    --sidebar-border-color: var(--gray-5);
    --sidebar-width: 20rem;
    --sidebar-width-xl: 24rem;
  }
</style>
<style scoped>
  .sidebar {
    flex: none;
    width: var(--sidebar-width);
    color: var(--dark-blue);
    background-color: #f4f4f4;
  }

  .nav {
    display: flex;
  }

  .nav-link {
    flex-basis: 33.33333%;
    padding: .75rem;
    text-align: center;
    font-weight: 600;
    font-size: .75rem;
    text-decoration: none;
    color: var(--blue);
    text-transform: uppercase;
    background-color: var(--gray-7);
    box-shadow: inset 0 -1px 0 var(--sidebar-border-color);
  }

  .nav-link.nav-spacer {
    flex: 1 1 0;
    padding: 0;
  }

  .nav-link.nav-link-active {
    background-color: #f4f4f4;
    box-shadow: inset 1px 0 0 var(--sidebar-border-color), inset -1px 0 0 var(--sidebar-border-color);
  }

  .nav-link.nav-link-active:first-child {
    box-shadow: inset -1px 0 0 var(--sidebar-border-color);
  }

  .nav-link.nav-link-active:last-child {
    box-shadow: inset 1px 0 0 var(--sidebar-border-color);
  }

  .count {
    display: block;
    color: var(--dark-blue);
  }

  .notification {
    position: absolute;
    top: -18px;
    right: -36px;
  }

  @media (--breakpoint-xl) {
    .sidebar {
      width: var(--sidebar-width-xl);
    }
  }

  @custom-media --breakpoint-xs (max-width: 40em);
  @custom-media --breakpoint-lg (min-width: 64em);
  @custom-media --breakpoint-xl (min-width: 80em);

</style>
